<span class="detail-simple-card-value">{{ value() | infoDisplay }}</span>
